import SectionHeadingSkeleton from "@/components/Skeleton/SectionHeadingSkeleton";
import TableSkeleton from "@/components/Skeleton/TableSkeleton";

export default function MyJobsSkeleton() {
  return (
    <div data-testid="my-jobs-skeleton">
      <SectionHeadingSkeleton />
      <TableSkeleton className="!mt-0" columns={8} rows={6} />
    </div>
  );
}
